import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import { events, apiEvents } from 'utils/Api/Api';
import { Url } from 'utils/urls';
import { RootDispatch } from 'storage/store';
import { MessageTypes } from 'storage/user/user.model';
import ErrorModal from 'components/Modal/modals/Error';

const GlobalErrors = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<RootDispatch>();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { pathname } = useLocation();
  const pathnameRef = useRef(pathname);
  const isOfferPage = pathname.includes(Url.offer);
  const handleCloseModal = async () => {
    setIsModalOpen(false);
    if (!isOfferPage) {
      return;
    }
    const response = await dispatch.application.getEodStatus();
    if (response && response.eodProcessing) {
      navigate(Url.dashboard);
    }
  };

  useEffect(() => {
    events.on(apiEvents.TOKEN_EXPIRED, () => {
      dispatch.user.logoutUser();
      if (pathnameRef.current === Url.technicalBreak) {
        return;
      }
      navigate(Url.login);
    });

    events.on(apiEvents.GENERAL_ERROR, () => {
      setIsModalOpen(true);
    });
    events.on(apiEvents.NOT_FOUND, () =>
      navigate(Url.notFound, { replace: true })
    );
    events.on(apiEvents.ERROR, () => navigate(Url.error));
    events.on(apiEvents.SESSION_EXPIRED, async () => {
      await dispatch.user.logoutUser();
      dispatch.user.changeUserStatus(MessageTypes.sessionExpired);
      navigate(Url.login);
    });
  }, []);
  return <ErrorModal open={isModalOpen} onClose={handleCloseModal} />;
};

export default GlobalErrors;
